import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont } from '../../theme/fundingTypography'

export const useStyles = makeStyles()(() => ({
  note: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.onSurface,
  },
  icon: {
    marginRight: 6,
    fontSize: 14,
    verticalAlign: -1,
    color: C.onSurface,
  },
  supportLink: {
    fontFamily: fundingFont,
    color: C.linkBlue,
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  },
}))
